/**
 * @file useRefFunction 引用获取
 */
import { useCallback, useRef } from 'react';
export function useRefFunction(callback) {
  var ref = useRef(callback);
  ref.current = callback;
  return useCallback(function () {
    return ref.current.apply(ref, arguments);
  }, []);
}